import { Controller } from '@hotwired/stimulus';
import { ClearPaymentAccountsMixin } from '../../../mixins/clear_payment_accounts_mixin';

export default class extends Controller {
  static values = {
    sourceTurboFrameTagName: String,
    sourceSelectSelector: String,
    receiverTurboFrameTagName: String,
    receiverSelectSelector: String,
  };

  static targets = [
    'sourceNeedyIdInputWrapper',
    'sourceFoundationIdInputWrapper',
    'receiverNeedyIdInputWrapper',
    'receiverFoundationIdInputWrapper',
  ];

  initialize() {
    ClearPaymentAccountsMixin(this);
  }

  clear_source({ params: { needyVisible, foundationVisible } }) {
    this.change_visibility(
      this.sourceNeedyIdInputWrapperTarget,
      needyVisible,
      this.sourceFoundationIdInputWrapperTarget,
      foundationVisible,
    );

    this.sourceNeedyIdInputWrapperTarget.querySelector('input').value = null;
    this.sourceFoundationIdInputWrapperTarget.querySelector('input').value =
      null;

    this.clear_source_results();
  }

  change_visibility(
    needyWrapper,
    needyVisible,
    foundationWrapper,
    foundationVisible,
  ) {
    if (needyVisible) {
      needyWrapper.classList.remove('hidden');
    } else {
      needyWrapper.classList.add('hidden');
    }

    if (foundationVisible) {
      foundationWrapper.classList.remove('hidden');
    } else {
      foundationWrapper.classList.add('hidden');
    }
  }

  clear_source_results() {
    this.clear_payment_accounts(
      this.sourceSelectSelectorValue,
      this.sourceTurboFrameTagNameValue,
    );
  }

  clear_receiver({ params: { needyVisible, foundationVisible } }) {
    this.change_visibility(
      this.receiverNeedyIdInputWrapperTarget,
      needyVisible,
      this.receiverFoundationIdInputWrapperTarget,
      foundationVisible,
    );

    this.receiverNeedyIdInputWrapperTarget.querySelector('input').value = null;
    this.receiverFoundationIdInputWrapperTarget.querySelector('input').value =
      null;

    this.clear_receiver_results();
  }

  clear_receiver_results() {
    this.clear_payment_accounts(
      this.receiverSelectSelectorValue,
      this.receiverTurboFrameTagNameValue,
    );
  }

  enforceCharacterLimit(event) {
    const maxLength = 7;
    if (event.target.value.length > maxLength) {
      event.target.value = event.target.value.slice(0, maxLength);
    }
  }
}
